import { useState, useEffect } from "react";
import { Dialog, DialogContent } from "@mui/material";
import { config } from "../config";

/**
 *
 * @param {{ text?: string | JSX.Element, isOpen?: boolean, onClose?: () => void }} props
 * @returns
 */
const MintedDialog = (props) => {
  const { isOpen, onClose, userAccount } = props;
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (isOpen) setOpen(true);
    else setOpen(false);
  }, [isOpen]);

  const handleClose = () => {
    setOpen(false);
    onClose && onClose();
  };

  return (
    <>
      <Dialog
        open={open}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
        fullWidth
        className="message-dialog"
      >
        <DialogContent
          style={{
            textAlign: "center",
          }}
        >
          <div className="message-dialog-text">{"Minted successfully"}</div>
          <button
            className={`view-your-frogs`}
            onClick={() => {
              window.open(
                `https://${config.openseaDomain}/${userAccount}?search[collections][0]=${config.openseaCollectionName}`,
                "_blank"
              );
            }}
          >
            View Your Frogs Over Dogs
          </button>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default MintedDialog;
